// src/components/messaging/MessagingContainer.tsx
// The messaging button now lives in TopBar — this component only renders the panel.
import React from "react";
import MessagingPanel from "./MessagingPanel";
import { useMessagingPanel } from "../../context/MessagingContext";

const MessagingContainer: React.FC = () => {
	const { isPanelOpen, closePanel } = useMessagingPanel();

	return <MessagingPanel open={isPanelOpen} onClose={closePanel} />;
};

export default MessagingContainer;
